// Action Types
export const SET_MYTHIC_DUNGEON_INVITATIONAL_DATA = 'SET_MYTHIC_DUNGEON_INVITATIONAL_DATA';
export const SET_MYTHIC_DUNGEON_INVITATIONAL_SUMMARY = 'SET_MYTHIC_DUNGEON_INVITATIONAL_SUMMARY';
export const SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD = 'SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD';
export const SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD_FILTER = 'SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD_FILTER';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';

// Action Creator
const MythicDungeonInvitationalActionCreator = {
  setMythicDungeonInvitationalData(data: any) {
    return {
      type: SET_MYTHIC_DUNGEON_INVITATIONAL_DATA,
      payload: data
    };
  },

  setMythicDungeonInvitationalSummary(data: any) {
    return {
      type: SET_MYTHIC_DUNGEON_INVITATIONAL_SUMMARY,
      payload: data
    };
  },

  setMythicDungeonInvitationalLeaderboard(data: any) {
    return {
      type: SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD,
      payload: data
    };
  },

  setLeaderboardFilter(data: any) {
    return {
      type: SET_MYTHIC_DUNGEON_INVITATIONAL_LEADERBOARD_FILTER,
      payload: data
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default MythicDungeonInvitationalActionCreator;
